// src/components/Summary/SelectedFiltersDisplay.js
import React from 'react';
import './SelectedFiltersDisplay.css';
import { dietaryRestrictionsList } from '../../data/filterOptions'; // To get labels for dietary keys

const SelectedFilterTag = ({ label, onRemove, type }) => (
  <span className={`filter-tag ${type}-tag`}>
    {label}
    {onRemove && ( // Only show 'x' if onRemove is provided
      <button type="button" onClick={onRemove} className="remove-tag-button" aria-label={`Remove ${label}`}>
        ×
      </button>
    )}
  </span>
);

const SelectedFiltersDisplay = ({
  selectedForms,
  selectedDietary,
  selectedGoals,
  selectedIngredients,
  onRemoveForm,
  onRemoveDietary,
  onRemoveGoal,
  onRemoveIngredient
}) => {
  const activeForms = Object.entries(selectedForms)
    .filter(([, isActive]) => isActive)
    .map(([form]) => form);

  // Get labels for dietary restriction keys
  const activeDietaryLabels = Object.entries(selectedDietary)
    .filter(([, isActive]) => isActive)
    .map(([key]) => {
      const foundRestriction = dietaryRestrictionsList.find(r => r.key === key);
      return foundRestriction ? foundRestriction.label : key;
    });

  const hasSelections =
    activeForms.length > 0 ||
    activeDietaryLabels.length > 0 ||
    selectedGoals.length > 0 ||
    selectedIngredients.length > 0;

  if (!hasSelections) {
    return null; // Don't render anything if no filters are selected
  }

  return (
    <div className="selected-filters-container">
      <h4>Current Selections:</h4>
      <div className="tags-area">
        {activeForms.map(form => (
          <SelectedFilterTag
            key={`form-${form}`}
            label={form}
            onRemove={onRemoveForm ? () => onRemoveForm(form) : null}
            type="form"
          />
        ))}
        {activeDietaryLabels.map(label => (
          <SelectedFilterTag
            key={`diet-${label}`} // Use label as key since it's derived
            label={label}
            onRemove={onRemoveDietary ? () => {
                // Need to find the original key to remove
                const restriction = dietaryRestrictionsList.find(r => r.label === label);
                if (restriction) onRemoveDietary(restriction.key);
            } : null}
            type="dietary"
          />
        ))}
        {selectedGoals.map(goal => (
          <SelectedFilterTag
            key={`goal-${goal}`}
            label={goal}
            onRemove={onRemoveGoal ? () => onRemoveGoal(goal) : null}
            type="goal"
          />
        ))}
        {selectedIngredients.map(ingredient => (
          <SelectedFilterTag
            key={`ing-${ingredient}`}
            label={ingredient}
            onRemove={onRemoveIngredient ? () => onRemoveIngredient(ingredient) : null}
            type="ingredient"
          />
        ))}
      </div>
    </div>
  );
};

export default SelectedFiltersDisplay;
